<template>
    <div class="container-fluid stdenis-login">
        <div class="row">
            <div class="col-12">
                <div class="col-lg-4 col-md-12 offset-lg-4">
                    <form role="form" class="vld-parent" ref="formContainer" @submit.prevent="processLogin">
                        <div class="card">
                            <h5 class="card-header">Parishioner Login Page</h5>
                            <div class="card-body">
                                <div class="form-group text-left">
                                    <label>Phone Number</label>
                                    <input type="tel" class="form-control" placeholder="phone" v-model="phone" required>
                                </div>
                                <div class="form-group text-left">
                                    <label>Password</label>
                                    <input type="password" class="form-control" placeholder="password" v-model="password" required>
                                </div>
                                <p class="card-text">
                                    Click the button below to log into your family dashboard
                                </p>
                                <button type="submit" class="btn btn-primary">Login <i class="icon ion-md-log-in text-white"></i> </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Swal from 'sweetalert2/dist/sweetalert2.js'
    import {firestoreDB} from '../config/firebase'

    const parishioners = firestoreDB.collection("parishioners");

    export default {
        name: "Login",
        data(){
            return {
                fullPage:true,
                phone:'', password:''
            }
        },
        methods: {
            processLogin(){
                let loader = this.showLoadingOverlay();
                let tmp_passkey = (this.phone + this.password).toLowerCase();
                var query = parishioners.where("passkey", "==", tmp_passkey).limit(1);
                query.get().then((querySnaphot) => {
                    if(querySnaphot.empty){
                        loader.hide();
                        this.display_alert('Oops!', "Incorrect Login Details","error");
                    }else{
                        querySnaphot.forEach((doc) => {
                            if(doc.exists){
                                this.display_alert('Success!', "Login Approved","success");
                                loader.hide();
                                sessionStorage.setItem("dashboardID", doc.id);
                                this.$router.push({name:"Dashboard"})
                            }
                        });
                    }
                }).catch((error)=>{
                    loader.hide();
                    this.display_alert('Oops!', error,"error");
                })
            },
            display_alert: function(msg_head, message, error_type){
                Swal.fire({
                    title: msg_head,
                    showClass: {
                        popup: 'animated fadeInDown faster'
                    },
                    hideClass: {
                        popup: 'animated fadeOutUp faster'
                    },
                    text: message,
                    icon: error_type,
                    showCancelButton: false,
                    showConfirmButton: false,
                    timer: 2000

                })
            },
            showLoadingOverlay(){
                return this.$loading.show({
                    // Optional parameters
                    container: this.fullPage ? null : this.$refs.formContainer,
                    canCancel: false,
                });
            },
        },
        mounted() {
            window.scrollTo(0,0)
        }
    }
</script>

<style scoped>
    .stdenis-login{
        padding: 60px 0;
    }
</style>